import { useQuery } from '@tanstack/react-query';

import { getConsultationDoubleBookings } from '@/api/consultations/getConsultationDoubleBookings';
import { QueryKey } from '@/data/query';

export const useGetConsultationDoubleBookings = () => {
  const { data, isError, isLoading } = useQuery({
    queryKey: [QueryKey.ConsultationBookingIssues],
    queryFn: () => getConsultationDoubleBookings(),
    refetchOnMount: 'always'
  });

  return {
    data,
    isError,
    isLoading
  };
};
